import React from 'react';
import { DashboardLayout } from './DashboardLayout';
import { Button } from '../ui';
import { FileTextIcon, ExternalLinkIcon, BarChart3Icon, DownloadIcon, SparklesIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ReportsPage() {
  return <DashboardLayout pageTitle="Reports & Analytics" breadcrumb="Leadership Reset Retreat" data-id="element-1760">
      <div className="grid lg:grid-cols-2 gap-8 mb-8" data-id="element-1761">
        {/* Main Report Card */}
        <div className="bg-white rounded-2xl border border-slate-200 shadow-soft p-8 relative overflow-hidden" data-id="element-1762">
          <div className="absolute top-0 right-0 w-32 h-32 bg-brand-teal/10 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2" data-id="element-1763" />

          <div className="flex items-center gap-3 mb-6 relative z-10" data-id="element-1764">
            <div className="w-12 h-12 bg-brand-navy text-white rounded-xl flex items-center justify-center shadow-md" data-id="element-1765">
              <BarChart3Icon className="w-6 h-6" data-id="element-1766" />
            </div>
            <div data-id="element-1767">
              <h2 className="text-2xl font-bold text-brand-navy" data-id="element-1768">
                Post-Event Report
              </h2>
              <p className="text-slate-500" data-id="element-1769">Comprehensive analysis & ROI</p>
            </div>
          </div>

          <div className="space-y-4 mb-8 relative z-10" data-id="element-1770">
            <div className="flex justify-between items-center p-3 bg-slate-50 rounded-lg border border-slate-100" data-id="element-1771">
              <span className="text-sm font-medium text-slate-700" data-id="element-1772">Status</span>
              <span className="bg-emerald-100 text-emerald-700 text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-1773">
                Ready to Share
              </span>
            </div>
            <div className="flex justify-between items-center p-3 bg-slate-50 rounded-lg border border-slate-100" data-id="element-1774">
              <span className="text-sm font-medium text-slate-700" data-id="element-1775">
                Data Points
              </span>
              <span className="text-sm font-bold text-brand-navy" data-id="element-1776">
                1,248 analyzed
              </span>
            </div>
            <div className="flex justify-between items-center p-3 bg-slate-50 rounded-lg border border-slate-100" data-id="element-1777">
              <span className="text-sm font-medium text-slate-700" data-id="element-1778">
                AI Insights
              </span>
              <span className="text-sm font-bold text-brand-coral flex items-center gap-1" data-id="element-1779">
                <SparklesIcon className="w-3.5 h-3.5" data-id="element-1780" /> Generated
              </span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 relative z-10" data-id="element-1781">
            <Button variant="primary" className="flex-1" href="/report" data-id="element-1782">
              View Interactive Report{' '}
              <ExternalLinkIcon className="w-4 h-4 ml-2" data-id="element-1783" />
            </Button>
            <Button variant="outline" data-id="element-1784">
              <DownloadIcon className="w-4 h-4 mr-2" data-id="element-1785" /> PDF
            </Button>
          </div>
        </div>

        {/* Mini Reports */}
        <div className="space-y-4" data-id="element-1786">
          <h3 className="text-lg font-bold text-brand-navy mb-4" data-id="element-1787">
            Exportable Data
          </h3>

          <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex items-center justify-between group hover:border-brand-teal/50 transition-colors" data-id="element-1788">
            <div className="flex items-center gap-3" data-id="element-1789">
              <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center text-slate-500 group-hover:bg-brand-teal/10 group-hover:text-brand-teal transition-colors" data-id="element-1790">
                <FileTextIcon className="w-5 h-5" data-id="element-1791" />
              </div>
              <div data-id="element-1792">
                <div className="font-bold text-slate-900" data-id="element-1793">Raw Survey Data</div>
                <div className="text-xs text-slate-500" data-id="element-1794">
                  CSV format • All responses
                </div>
              </div>
            </div>
            <Button variant="ghost" size="sm" data-id="element-1795">
              <DownloadIcon className="w-4 h-4" data-id="element-1796" />
            </Button>
          </div>

          <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex items-center justify-between group hover:border-brand-teal/50 transition-colors" data-id="element-1797">
            <div className="flex items-center gap-3" data-id="element-1798">
              <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center text-slate-500 group-hover:bg-brand-teal/10 group-hover:text-brand-teal transition-colors" data-id="element-1799">
                <FileTextIcon className="w-5 h-5" data-id="element-1800" />
              </div>
              <div data-id="element-1801">
                <div className="font-bold text-slate-900" data-id="element-1802">
                  Attendee Commitments
                </div>
                <div className="text-xs text-slate-500" data-id="element-1803">
                  CSV format • 43 commitments
                </div>
              </div>
            </div>
            <Button variant="ghost" size="sm" data-id="element-1804">
              <DownloadIcon className="w-4 h-4" data-id="element-1805" />
            </Button>
          </div>

          <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex items-center justify-between group hover:border-brand-teal/50 transition-colors" data-id="element-1806">
            <div className="flex items-center gap-3" data-id="element-1807">
              <div className="w-10 h-10 bg-slate-100 rounded-lg flex items-center justify-center text-slate-500 group-hover:bg-brand-teal/10 group-hover:text-brand-teal transition-colors" data-id="element-1808">
                <FileTextIcon className="w-5 h-5" data-id="element-1809" />
              </div>
              <div data-id="element-1810">
                <div className="font-bold text-slate-900" data-id="element-1811">
                  Dietary & Logistics
                </div>
                <div className="text-xs text-slate-500" data-id="element-1812">
                  CSV format • For BEOs
                </div>
              </div>
            </div>
            <Button variant="ghost" size="sm" data-id="element-1813">
              <DownloadIcon className="w-4 h-4" data-id="element-1814" />
            </Button>
          </div>
        </div>
      </div>
    </DashboardLayout>;
}